export default "__VITE_ASSET__BOnfT1mT__"